function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFAF20"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "M19 25a7 7 0 0 1-7 7c-3.867 0-7-3.133-7-7a7 7 0 0 1 14 0zM24 25c0 3.867 3.133 7 7 7a7 7 0 1 0-7-7zM19 25c0-1.104 1.118-2 2.5-2 1.378 0 2.5.896 2.5 2"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M5 26V3.679C5 2.2 5.895 1 7 1M38 26V3.679C38 2.2 37.103 1 36 1"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M40.5 1L.5 36"
}));

var SvgGlassesIcon = function SvgGlassesIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 37,
    viewBox: "0 0 41 37",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGlassesIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/glasses_icon.7e7a333a.svg";
export { ForwardRef as ReactComponent };